<template>
  <div class="flex flex-col items-center">
    <div
      class="relative flex flex-col items-center text-center w-full max-w-[40rem] sm:max-w-[1120px] h-full px-20 sm:px-40 lg:px-0 pt-80 pb-24 sm:pb-40 md:pb-0 sm:pt-128 md:-mb-64"
    >
      <h1>{{ $t("contact_page.title") }}</h1>

      <div class="sm:text-20 max-w-[680px] mb-40 md:mb-80">
        {{ $t("contact_page.description") }}
      </div>

      <div class="h-auto w-full rounded-lg overflow-hidden">
        <PagesContactCalendarEmbed />
      </div>
    </div>

    <div
      class="flex justify-center w-full md:bg-dark py-80 md:py-128 mb-24 sm:mb-160 md:mb-256"
    >
      <div
        class="flex flex-col-reverse md:flex-row gap-8 w-full max-w-[40rem] md:max-w-[calc(90vw)] xl:max-w-[1480px] px-4 sm:px-40 lg:px-0"
      >
        <!-- <PagesLandingpageTestimonial id="contact-testimonial" /> -->

        <img
          :src="unique"
          class="hidden lg:block grow w-full lg:w-512 rounded-xl"
        />

        <div class="shrink-0 w-full md:flex md:flex-col md:gap-8 md:w-fit">
          <div
            class="flex justify-between items-center w-full text-14 bg-[#e6cd90] p-8 rounded-full mb-8 md:mb-0"
          >
            <div class="flex items-center sm:mr-40">
              <img
                :src="hans"
                class="shrink-0 h-40 w-40 sm:h-[52px] sm:w-[52px] rounded-full object-cover object-top"
              />

              <div>
                <div
                  class="shrink-0 text-16 ml-12 sm:ml-20 leading-xs sm:leading-s"
                >
                  <div class="font-bold">Hans Fuchs</div>
                  <div class="text-14">Founder</div>
                </div>
              </div>
            </div>

            <SharedLink url="https://cal.com/hyperfocused/demo">
              <UiButton size="small" class="hidden sm:flex">
                {{ $t("call_banner.cta") }}
              </UiButton>
              <UiButton size="tiny" class="sm:hidden">
                {{ $t("call_banner.cta") }}
              </UiButton>
            </SharedLink>
          </div>

          <div
            class="grow w-full md:w-[400px] lg:w-512 p-40 bg-[#e6cd90] rounded-xl"
          >
            <h3>Support</h3>

            <SharedLink
              v-for="(link, i) in contact"
              :key="i"
              :url="link.target"
              class="w-fit underline whitespace-nowrap"
            >
              {{ link.text }}
            </SharedLink>

            <div class="mt-20">
              {{ $t("contact_page.support_description") }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <PagesLandingpageReferralsCta />
  </div>
</template>

<script lang="ts" setup>
import hans from "~/assets/img/hans.webp";
import unique from "~/assets/img/landingpage/concept-unique.webp";

const contact = [
  {
    text: "hey@hyperfocused.agency",
    target: "mailto:hey@hyperfocused.agency",
  },
  {
    text: "+49 152 05997236",
    target: "tel:+4915205997236",
  },
];
</script>

<style lang="scss">
#contact-testimonial {
  @apply px-0;

  img {
    @apply object-[40%];
  }

  > div:first-child {
    @apply px-0;
  }

  #testimonial-quote-container {
    @apply p-24 sm:p-40 lg:p-40;
  }
}

#cal-container .hidden-bar {
  @apply bg-dark;
}
</style>
